export default "__VITE_PUBLIC_ASSET__afc9ae5a__"